import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { secondary } = theme.palette;

  return {
    stableEntriesCount: {
      fontSize: 16,
      marginTop: 16,
      lineHeight: "40px"
    },
    stableEntriesContainer: {
      maxHeight: 212,
      overflowY: "auto",
      margin: "0 -24px"
    },
    stableEntryRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 33,
      padding: "0 38px 0 24px",
      fontSize: 12,
      borderTop: "1px solid #eee",
      "&:nth-child(odd)": {
        backgroundColor: "#f7f7f7"
      }
    },
    approveIcon: {
      color: secondary.dark
    },
    denyIcon: {
      color: "#d82f44"
    }
  };
});
